import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from './Header';
import { MANUALS, manualSrc } from './manuals';
import './UserManual.css';

/* A MANUAL ON A PAGE OF ITS OWN — what "Open in new tab" and a right-click on a module's Manual button open (Max 01/11).
   Until 01/11 the handbooks were also rows in the sidebar (Jay, task #99, 30/10: "open inside the Portal, not in a new
   browser tab"); now every module carries its own Manual button (ModuleHelp.jsx) and this page is where it lands in a
   tab. Any key in manuals.js, in the portal's language; an unknown name lands on the Project Tracker's. */
export default function UserManual() {
    const { which } = useParams();
    const { t, i18n } = useTranslation();
    const src = manualSrc(MANUALS[which] ? which : 'project', i18n.language);
    return (
        <div className="sp-page">
            <Header />
            <div className="sp-main um-page">
                <iframe key={src} className="um-frame" src={src} title={t('xHelp.manual')} data-um-frame={which} />
            </div>
        </div>
    );
}
